var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"home"},[_c('encabezado',{attrs:{"data":'home'}}),_vm._v(" "),(_vm.isEmpresa)?_c('home-empresa'):_vm._e(),_vm._v(" "),(_vm.isAlumno)?_c('home-alumno'):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4c70388c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./submodules/dotia-base-fp/src/components/views/home/home.vue
// module id = null
// module chunks = 